module.exports = __webpack_public_path__ + "static/media/noimage.1bdc5046.jpg";